import { Button } from '@sgcmpteltd/uikit-react';
import {
  BUTTON_COLOR_GRAY,
  BUTTON_VARIANT_OUTLINED,
} from '@sgcmpteltd/uikit-react/components/button';
import Image from 'next/image';

import { SITE_BASE_PATH } from '@/configs/site';
import { joinSgcmMedia, joinSgcmMsSite } from '@/utils/url/join/public';

import { Content } from './content';
import styles from './styles.module.scss';
import type { Component } from './types';

export const NoSearchResult: Component = ({
  isSearchClearable,
  pastCarList,
  message,
  title,
  redirectRoute,
  onSearchClear,
}) => (
  <div className={styles.containerRoot}>
    <Image
      alt="Mangifier with a question mark inside over an empty folder"
      height={144}
      src={`${joinSgcmMedia('/public/new-cars/no-search-results.svg')}`}
      width={164} />
    <div className={styles.containerContent}>
      <Content
        message={message}
        pastCarList={pastCarList}
        title={title} />
      {
        isSearchClearable && (
          <a
            className={styles.buttonClearSearch}
            href={`${joinSgcmMsSite(SITE_BASE_PATH ?? '')}${redirectRoute}`}
            rel="noreferrer noopener">
            <Button
              color={BUTTON_COLOR_GRAY}
              variant={BUTTON_VARIANT_OUTLINED}
              onClick={onSearchClear}>
              Clear Search
            </Button>
          </a>
        )
      }
    </div>
  </div>
);
